import 'twin.macro';
import React from 'react';
import { ReactComponent as Icon } from './status-todo.svg';
import { IconProps } from '@teetsh/app/src/components/Icons/icon';

export function StatusTodo(props: IconProps) {
  return <Icon tw="stroke-current" className={props.className} />;
}
